<template>
  <v-card class="mx-auto" max-width="1000" elevation="0" color="transparent">
    <v-breadcrumbs :items="items" class="px-0 pt-0">
      <template v-slot:prepend>
        <v-icon size="small" icon="mdi-home" class="mr-1" color="#343f53"></v-icon>
      </template>
      <template v-slot:divider>
        <v-icon icon="mdi-chevron-right" size="small" color="#666"></v-icon>
      </template>
      <template v-slot:item="{ item }">
        <v-breadcrumbs-item
          :disabled="item.disabled"
          :href="item.href"
          :style="{
            color: item.disabled ? '#666' : '#343f53',
            fontWeight: item.disabled ? '600' : '500'
          }"
        >
          {{ item.title }}
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>
  </v-card>
</template>

<script>
export default {
  name: "Breadcrumbs",
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style>
/* Estilos para os breadcrumbs */
:deep(.v-breadcrumbs) {
  font-size: 0.875rem;
}

:deep(.v-breadcrumbs-item--link) {
  color: #343f53;
  font-weight: 500;
}

:deep(.v-breadcrumbs-item--disabled) {
  color: #666;
  font-weight: 600;
}
</style>
